import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

type GetDiscountBody = {
  start: number;
  length: number;
  search: string;
};

type AddDiscountBody = {
  discount_name_ar: string;
  discount_name_en: string;
  discount_name_rs: string;
  discount_percentage: number;
  description_ar: string;
  description_en: string;
  description_rs: string;
  start_date: string;
  start_time: string;
  end_date: string;
  end_time: string;
  category: number;
  banner_image: number;
};

type UpdateDiscountParams = {
  body: {
    discount_name_ar: string;
    discount_name_en: string;
    discount_name_rs: string;
    discount_percentage: number;
    description_ar: string;
    description_en: string;
    description_rs: string;
    start_date: string;
    start_time: string;
    end_date: string;
    end_time: string;
    category: number;
    banner_image: number;
  };
  id: string | undefined;
};

type DiscountStatusParams = {
  body: {
    is_active: string;
  };
  id: string | undefined;
};

export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addDiscount: builder.mutation<
      CommonResponseType & { data: any },
      AddDiscountBody
    >({
      query: (body) => ({
        url: END_POINTS.addDiscount,
        method: "POST",
        body,
      }),
    }),

    getDiscountById: builder.query<
      CommonResponseType,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.discountById}${id}/`,
        method: "GET",
      }),
    }),

    getDiscount: builder.mutation<CommonResponseType, GetDiscountBody>({
      query: (body) => ({
        url: END_POINTS.allDiscount,
        method: "POST",
        body,
      }),
    }),

    updateDiscount: builder.mutation<CommonResponseType, UpdateDiscountParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDiscount}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    updateDiscountStatus: builder.mutation<
      CommonResponseType,
      DiscountStatusParams
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDiscount}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteDiscount: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteDiscount}${id}/`,
        method: "DELETE",
      }),
    }),

    getAllVendor: builder.query<CommonResponseType, {}>({
      query: ({}) => ({
        url: `${END_POINTS.allVendor}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddDiscountMutation,
  useLazyGetDiscountByIdQuery,
  useGetDiscountMutation,
  useUpdateDiscountMutation,
  useUpdateDiscountStatusMutation,
  useDeleteDiscountMutation,
  useLazyGetAllVendorQuery,
} = discountApi;
